import { Inject, Injectable, LOCALE_ID, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Language } from '../models/language';


@Injectable()
export class LanguageService {

    readonly languages: Language[] = [
        {
            codes: ['en-US', 'en'],
            label: 'EN',
            'href': 'en'
        },
        {
            codes: ['de', 'de-DE'],
            label: 'DE',
            'href': 'de'
        },
    ];


    constructor(@Inject(LOCALE_ID) private localeId: string, @Inject(DOCUMENT) private document: Document) {
        console.log('Locale ID', localeId);
    }

    getLanguages(): Language[] {
        return this.languages;
    }

    getCurrentLanguage(): Language | undefined {
        console.log("Locale parsed", this.localeId.split("-")[0].toLowerCase())
        return this.getLanguages().find(e => e.codes.includes(this.localeId.split("-")[0].toLowerCase()));
    }

    switchLanguage(language: Language) {
        // todo validation
        const newUrl = this.document.location.origin + `/${language.href}/` + this.document.location.href.split('/').slice(4).join('/');
        this.document.location.assign(newUrl);
    }
}
